// 파일명 → 확장자/아이콘/크기 포맷 유틸 (프로토타입과 동일 규칙)

export function getExt(name: string): string {
  return ('.' + name.split('.').pop()).toLowerCase();
}

export interface FileIcon {
  icon: string;
  cls: 'fi-img' | 'fi-vid' | 'fi-zip' | 'fi-danger' | 'fi-doc';
}

export function fileIcon(name: string): FileIcon {
  const ext = getExt(name);
  if (['.jpg', '.jpeg', '.png', '.gif', '.webp'].includes(ext)) return { icon: '🖼', cls: 'fi-img' };
  if (['.mp4', '.mov', '.avi'].includes(ext)) return { icon: '🎬', cls: 'fi-vid' };
  if (['.zip', '.tar', '.gz', '.rar'].includes(ext)) return { icon: '📦', cls: 'fi-zip' };
  if (['.exe', '.bat', '.sh', '.ps1'].includes(ext)) return { icon: '⚠', cls: 'fi-danger' };
  return { icon: '📄', cls: 'fi-doc' };
}

export function formatSize(b: number): string {
  if (b < 1024) return b + ' B';
  if (b < 1024 * 1024) return (b / 1024).toFixed(1) + ' KB';
  return (b / (1024 * 1024)).toFixed(1) + ' MB';
}
